export default {
      id: "color_bacteria_hello-usage",
      viewBox: "0 0 175 103",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_hello",
      toString: function () {
        return this.url;
      }
    }